import { render, staticRenderFns } from "./c-set-bf-category-name.vue?vue&type=template&id=96aeea44&scoped=true&"
import script from "./c-set-bf-category-name.vue?vue&type=script&lang=ts&"
export * from "./c-set-bf-category-name.vue?vue&type=script&lang=ts&"
import style0 from "./c-set-bf-category-name.vue?vue&type=style&index=0&id=96aeea44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96aeea44",
  null
  
)

export default component.exports